import script from "./MantenedorSyncDjango.vue?vue&type=script&setup=true&lang=js"
export * from "./MantenedorSyncDjango.vue?vue&type=script&setup=true&lang=js"

import "./MantenedorSyncDjango.vue?vue&type=style&index=0&id=4add0a8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4add0a8d"]])

export default __exports__